import Teaser from './components/Teaser.svelte';
const TeaserComponent = new Teaser({ // eslint-disable-line no-unused-vars
  target: document.querySelector('#Teaser')
});

import FailureCases from './components/FailureCases.svelte';
const FailureCasesComponent = new FailureCases({ // eslint-disable-line no-unused-vars
  target: document.querySelector('#FailureCases')
});

import Training from './components/Training.svelte';
const TrainingComponentPosEnc = new Training({ // eslint-disable-line no-unused-vars
  target: document.querySelector('#TrainingPosenc'),
});

import TrainingComparison from './components/TrainingComparison.svelte';
const TrainingComponentNoPosEnc = new TrainingComparison({ // eslint-disable-line no-unused-vars
  target: document.querySelector('#TrainingNoPosenc'),
});

// import VideoExample from './components/VideoExample.svelte';
// import examples from './components/video-examples.json';
// // video examples
// new VideoExample({
//   target: document.getElementById('fern200k'),
//   props: { example: examples.find(example => example.bibtex === 'fern200k')}
// });

import VoxelGrid from './components/VoxelGrid.svelte';
const VoxelGridComponent = new VoxelGrid({ // eslint-disable-line no-unused-vars
  target: document.querySelector('#VoxelGrid'),
});